var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStSaoTomeandPrincipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_23263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#12AD2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 12.8535H0V32.1566H60V12.8535Z",
    fill: "#FFCE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0V45L37.5 22.5",
    fill: "#D21034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0381 16.0713L29.0246 22.1853L25.9676 23.1786",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_23263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStSaoTomeandPrincipe);
export default __webpack_public_path__ + "static/media/st Sao Tome and Principe.4c585c395ef7106bc81929f902489ded.svg";
export { ForwardRef as ReactComponent };